import { getDebtorsOnCustomer, } from '@debbie/common/dist/customers/index.js';
import { Registry, } from '@debbie/common/dist/debt-register/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useRegistriesByCaseId } from '@debbie/cortex/dist/debt-registries/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import PlusCircle from '../Icons/PlusCircle.js';
import DebtRegistrationCard from './DebtRegistrationCard.js';
import DeleteModal from './DeleteModal.js';
import ErrorModal from './ErrorModal.js';
import MoveToOpenModal from './MoveToOpenModal.js';
import NewRegistrationModal from './NewRegistrationModal.js';
import { getAvailableRegistries } from './registries.js';
import StatusModal from './StatusModal.js';
const DebtRegistrationReporting = (props) => {
    const singleCase = props.case;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const tenant = useTenant();
    const debtRegistriesLoadable = useRegistriesByCaseId(singleCase?.caseId);
    const debtRegistries = h.hasData(debtRegistriesLoadable)
        ? debtRegistriesLoadable.data
        : [];
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [debtorUserId, setDebtorUserId] = useState(null);
    const [registrationId, setRegistrationId] = useState(null);
    // The registry of the registration whose modal (delete/status/move-to-open/
    // error) is currently open. Only one modal is open at a time, and every
    // card action sets this when opening its modal.
    const [activeRegistry, setActiveRegistry] = useState(Registry.RKI);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [moveToOpenModalOpen, setMoveToOpenModalOpen] = useState(false);
    const [registrationStatus, setRegistrationStatus] = useState(null);
    const debtors = getDebtorsOnCustomer(props.customer);
    const debtorUser = debtors.find((d) => d.userId === debtorUserId);
    useEffect(() => {
        if (!debtorUserId) {
            const debtorContact = debtors.find((d) => d.userOnCustomerId === singleCase.userOnCustomerId) || debtors[0];
            if (debtorContact) {
                setDebtorUserId(debtorContact.userId);
            }
        }
    }, [props.case]);
    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);
    const toggleMoveToOpenModal = () => setMoveToOpenModalOpen(!moveToOpenModalOpen);
    const toggleErrorOpenModal = () => setErrorModalOpen(!errorModalOpen);
    const toggleStatusModal = () => {
        setStatusModalOpen(!statusModalOpen);
        setRegistrationStatus(null);
    };
    const manglerAdvokatindestaaelse = tenant?.settings?.manglerAdvokatindestaaelse === true;
    const canRegister = creditor != null &&
        getAvailableRegistries(creditor, {
            withFoundation: true,
            manglerAdvokatindestaaelse,
        }).length > 0;
    return (React.createElement("div", null,
        site === Site.Caseworker && (React.createElement(DebtRegistrationReportingStyled, { onClick: canRegister
                ? toggleModal
                : () => alert('Kreditor er ikke oprettet hos nogen gældsregistreringsservice. Kontakt Debbie for hjælp.'), className: "ui-test-4da65h35", style: {
                cursor: canRegister ? 'pointer' : 'initial',
            } },
            React.createElement("h3", { className: "rki-title" },
                lang.debtRegistration.registration,
                React.createElement("small", null)),
            React.createElement("p", { className: "rki-interval" },
                React.createElement(PlusCircle, { style: {
                        margin: '.2em 0 -.2em',
                    } }),
                ' ',
                lang.debtRegistration.createNewRegistration))),
        deleteModalOpen && (React.createElement(DeleteModal, { case: props.case, toggleDeleteModal: toggleDeleteModal, userId: debtorUser && debtorUser.userId, registrationId: registrationId, registry: activeRegistry, customer: props.customer })),
        statusModalOpen && (React.createElement(StatusModal, { toggleStatusModal: toggleStatusModal, registry: activeRegistry, status: registrationStatus })),
        moveToOpenModalOpen && (React.createElement(MoveToOpenModal, { caseVouchers: props.caseVouchers, case: props.case, toggleMoveToOpenModal: toggleMoveToOpenModal, userId: debtorUser && debtorUser.userId, rkiReferenceId: registrationId, registry: activeRegistry, customer: props.customer })),
        errorModalOpen && (React.createElement(ErrorModal, { caseId: props.case.caseId, toggleErrorOpenModal: toggleErrorOpenModal, userId: debtorUser && debtorUser.userId, rkiReferenceId: registrationId, registry: activeRegistry, customer: props.customer })),
        modalOpen && (React.createElement(NewRegistrationModal, { caseVouchers: props.caseVouchers, case: props.case, debtorUser: debtorUser, userId: debtorUserId, setUserId: setDebtorUserId, toggleModal: toggleModal, customer: props.customer })),
        debtRegistries &&
            !!debtRegistries.length &&
            debtRegistries.map((registration) => (React.createElement(DebtRegistrationCard, { key: registration.registrationId, case: props.case, registration: registration, toggleDeleteModal: toggleDeleteModal, toggleMoveToOpenModal: toggleMoveToOpenModal, setErrorModalOpen: setErrorModalOpen, setStatusModalOpen: setStatusModalOpen, setStatus: setRegistrationStatus, setDebtorId: setDebtorUserId, setRegistrationId: setRegistrationId, setActiveRegistry: setActiveRegistry })))));
};
export default DebtRegistrationReporting;
const DebtRegistrationReportingStyled = styled.div `
  border-radius: 4px;
  background-color: ${THEME.FILL};
  padding: 5px;
  margin-bottom: 10px;

  .rki-title {
    font-size: 0.7em;

    small {
      font-size: 0.9em;
      float: right;
      font-weight: bold;
    }
  }

  .rki-interval {
    font-size: 0.6em;
    margin: 0.7em 0 0.4em 0;
  }

  .pp-delete {
    float: right;
    width: 14px;
    height: 14px;
    background-color: ${THEME.FILL};
    border-radius: 10px;
    padding: 2px 0 2px 1px;
    text-align: center;
    color: ${THEME.COLOR_SECONDARY};
    cursor: pointer;
  }
`;
//# sourceMappingURL=DebtRegistrationReporting.js.map